import React from 'react'
import { useDispatch } from 'react-redux'
import Button from '@mui/material/Button'
import authActions from '../../store/modules/auth'

const UnimpersonateButton: React.FC = () => {
  const dispatch = useDispatch()

  const handleUnimpersonate = () => {
    dispatch(authActions.unimpersonateUser())
  }

  return (
    <Button
      size="small"
      color="primary"
      variant="outlined"
      onClick={handleUnimpersonate}
    >
      Unimpersonate
    </Button>
  )
}

export default UnimpersonateButton